import React from 'react';
import ReportingDonationsYearOverYearPage from '../components/ReportingDonationsYearOverYearPage';

const ReportingDonationsYearOverYearApp = (props) => (
  <ReportingDonationsYearOverYearPage {...props} />
);

export default ReportingDonationsYearOverYearApp;
